import React, { useState, useEffect } from 'react'
import { Paper, Typography } from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import Backdrop from '@material-ui/core/Backdrop'
import CircularProgress from '@material-ui/core/CircularProgress'

import MainLayout from 'layout/MainLayout'
import MSettingTable from 'components/MSettingTable'
import MIntegrationDialog from 'components/MIntegrationDialog'
import api from 'utils/api'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(4),
      padding: theme.spacing(3),
      minHeight: 'calc(100vh - 180px)',
    },
    formControl: {
      display: 'flex',
      minWidth: 200,
      maxWidth: 200,
      marginTop: theme.spacing(2),
    },
    subTitle: {
      marginTop: theme.spacing(3),
    },
    backDrop: {
      zIndex: 9999,
    },
  }),
)

const columns = [
  { field: 't_id', headerName: 'ID' },
  { field: 'ad_platform', headerName: 'Ad Platform' },
  { field: 'user', headerName: 'User' },
  { field: 'date_added', headerName: 'Date Added' },
  { field: 'expire_date', headerName: 'Expire Date' },
]

const IntegrationsPage = () => {
  const classes = useStyles()

  const [rows, setRows] = useState<any[]>([])
  const [openDialog, setOpenDialog] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)

  const handleAdd = () => {
    setOpenDialog(true)
  }

  const confirmData = async (values) => {
    //console.log(values)
    setLoading(true)
    try {
      const res = await api.get('/integrations', values)
      setRows(res)
      setLoading(false)
    } catch {
      setLoading(false)
    }
  }

  const fetch = async () => {
    setLoading(true)
    try {
      const res = await api.get('/integrations/fetch')
      setRows(res)
      setLoading(false)
    } catch {
      setLoading(false)
    }
  }

  const onDelete = async (index) => {
    setLoading(true)
    try {
      const res = await api.get('/integrations/delete', { id: index })
      setRows(res)
      setLoading(false)
    } catch {
      setLoading(false)
    }
  }

  const onRefresh = async (index) => {
    setLoading(true)
    try {
      const res = await api.get('/integrations/refreshToken', { id: index })
      setRows(res)
      setLoading(false)
    } catch {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetch()
  }, [])
  
  return (
    <MainLayout title='Integrations'>
      <>
        <Paper className={classes.paper} elevation={3}>
          <Grid container style={{ marginBottom: '20px' }}>
            <Grid item>
              <Typography variant='h6'>Integrations</Typography>
            </Grid>
            <Grid item style={{ marginLeft: 'auto' }}>
              <Button color='primary' variant='contained' onClick={handleAdd}>
                {' '}
                Add Integration{' '}
              </Button>
            </Grid>
          </Grid>
          <Grid container>
            <MSettingTable
              columns={columns}
              rows={rows}
              handleProps={[
                { text: 'Refresh', handler: onRefresh },
                { text: 'Delete', handler: onDelete },
              ]}
            />
          </Grid>
        </Paper>

        <MIntegrationDialog
          open={openDialog}
          setOpen={setOpenDialog}
          confirm={confirmData}
        />

        <Backdrop open={loading} className={classes.backDrop}>
          <CircularProgress color='inherit' />
        </Backdrop>
      </>
    </MainLayout>
  )
}

export default IntegrationsPage
